import get from './methodGet';
import put from './methodPut';

export default { ...get, ...put };
